export default __webpack_public_path__ + "static/affiliate-program-Software-2@mob2x-7c429a7f81922d1b2ddd5e56fd2b2ac7.jpg";